import React from "react";
import GameItem from "./GameItem";
import { checkBonusGame, updateImageUrl } from "../../../utils/utils.js";

export default function GameItemSupportBonus({ currentGame, origImage, isHistoryGames, ...props }) {
  const isBonus = checkBonusGame(currentGame);
  let newCurrentGame = { ...currentGame };

  const itemImg =
    origImage || isBonus ? newCurrentGame.image : updateImageUrl(newCurrentGame.image);

  return (
    <GameItem
      {...props}
      currentGame={newCurrentGame}
      name={newCurrentGame.name}
      image={itemImg}
      isHistoryGames={isHistoryGames}
      url={isBonus ? "/bonus_game/" : props.url}
    />
  );
}
